import Groups from "../models/Groups";

const GroupStore = Groups.create();

export default GroupStore;
